import { FEATURE_FLAG, getFeatureFlag } from '@phoenix/helpers/feature-flag-helper';

export default {
  computed: {
    fieldsClass() {
      return {
        address2: 'md:w-1/3',
        address5: getFeatureFlag(FEATURE_FLAG.GEMINI_TW) || getFeatureFlag(FEATURE_FLAG.HK_NEW_FORM) ? '' : 'md:w-2/3',
        address7: 'md:w-2/3',
        zip: 'md:w-1/3',
      };
    },
  },
};
